import { IntelliCatchMessageAction } from './intellicatch-message.enum';

// The widget iframe in the host page. Shared by everything that has to find it, so the host and
// the sender cannot drift onto two different selectors.
export const CHAT_IFRAME_SELECTOR = '.chat-iframe';

export const BLANK_FRAME_URL = 'about:blank';

// Upper bound on the plain-text description handed to the widget. Long enough for a real
// specification, short enough that the prompt still leaves room for an answer.
export const INTELLICATCH_ITEM_CONTEXT_DESCRIPTION_MAX_CHARS = 6000;

/** The item this app currently has attached to an IntelliCatch conversation. */
export interface IIntelliCatchItemContext {
  sessionId: string;
  nodeId: string;
  key: string;
  itemType: string;
  summary: string;
  description: string;
  descriptionTruncated: boolean;
}

/**
 * One item attached during this page's IntelliCatch conversation, with where it lives. Answers keep
 * the session they were generated for, so a create names a session that may no longer be attached;
 * the label and project say whether the user is still somewhere it can be created under.
 */
export interface IIntelliCatchItemSession {
  context: IIntelliCatchItemContext;
  workspaceId: string;
  workspaceKey: string;
  workspaceName: string;
  projectId: string;
  projectKey: string;
  projectName: string;
}

/** Where a create should go: the item to link it to, or the sentence saying why it cannot be made. */
export interface IIntelliCatchCreateTarget {
  itemContext: IIntelliCatchItemContext | null;
  refusal: string;
}

export interface IIntelliCatchSetItemContextPayload {
  sessionId: string;
  key: string;
  itemType: string;
  summary: string;
  description: string;
  descriptionTruncated: boolean;
  initialPrompt: string;
}

export interface IIntelliCatchClearItemContextPayload {
  sessionId: string;
  reason: string;
}

/** Host -> widget: start the conversation over, with the sentence saying why. */
export interface IIntelliCatchResetConversationPayload {
  reason: string;
}

export interface IIntelliCatchHostMessage {
  action: IntelliCatchMessageAction;
  payload: IIntelliCatchSetItemContextPayload | IIntelliCatchClearItemContextPayload | IIntelliCatchResetConversationPayload;
}
